import normalizeSpeechPhrases from '@UI/Pages/Administration/AiEngines/Sidebars/ModelSidebar/Helpers/normalizeSpeechPhrases';
import {
	AZURE_SPEECH_FAMILY,
	SPEECH_PHRASE_MAX_LENGTH,
} from '@UI/Pages/Administration/AiEngines/azureSpeechValues';

/** The minimal shape this constraint reads. */
type SpeechShape = {
	readonly family: string | null;
	readonly hasAzureSpeechSettings: boolean;
};

/** Active only when the Azure Speech settings section is shown: no normalized phrase over 200 characters. */
function isSpeechPhraseLengthValid<T extends SpeechShape>(value: string, formData: T): boolean {
	if (formData.family !== AZURE_SPEECH_FAMILY || !formData.hasAzureSpeechSettings) {
		return true;
	}

	return normalizeSpeechPhrases(value).every((phrase) => phrase.length <= SPEECH_PHRASE_MAX_LENGTH);
}

export default isSpeechPhraseLengthValid;
